import Highlight, { defaultProps } from "prism-react-renderer";
import theme from "prism-react-renderer/themes/github";
import { Pre, Line, LineNo, LineContent } from "./styles";

// JS Sample Code
const javascript = `const JSEncrypt = require("node-jsencrypt"); const jsEncrypt = new JSEncrypt();
const encryptJsonData = (body) => { jsEncrypt.setPublicKey(getCache("publicKey"));
var data = {};
for (let key in body) {
    if (Array.isArray(bodykey) && bodykey.every(i => (typeof i === "string"))) {
        let arrayOfElements = bodykey; let arrayOfEncryptedElements = [];
        for (let element in arrayOfElements)
            {
            let encryptedData = jsEncrypt.encrypt(arrayOfElementselement).toString();
            arrayOfEncryptedElements.push(encryptedData);
            }
            datakey = JSON.stringify(arrayOfEncryptedElements);
    }
    else if (Array.isArray(bodykey))
    {
        let arrayOfElements = bodykey;
        let arrayOfEncryptedElements = [];
        for (let element in arrayOfElements)
            {
            let model = {};
            let unencryptedModel = arrayOfElementselement;
            for (let jKey in unencryptedModel)
            {
                let dataToEncrypt = unencryptedModeljKey.toString();
                let encryptedData = jsEncrypt.encrypt(dataToEncrypt).toString();
                modeljKey = encryptedData;
            }
        arrayOfEncryptedElements.push(model);
    }
    datakey = JSON.stringify(arrayOfEncryptedElements);
    }
    else
    {
        let dataToEncrypt = bodykey.toString();
        if (dataToEncrypt.includes("Object"))
        dataToEncrypt = JSON.stringify(bodykey);
 
        datakey = jsEncrypt.encrypt(dataToEncrypt).toString();
    }
}
return data;
}`;

function EJD() {
  return (
    <Highlight
      {...defaultProps}
      theme={theme}
      code={javascript}
      language="javascript"
    >
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <Pre className={className} style={style}>
          {tokens.map((line, i) => (
            <Line key={i} {...getLineProps({ line, key: i })}>
              <LineNo>{i + 1}</LineNo>
              <LineContent>
                {line.map((token, key) => (
                  <span key={key} {...getTokenProps({ token, key })} />
                ))}
              </LineContent>
            </Line>
          ))}
        </Pre>
      )}
    </Highlight>
  );
}
export default EJD;
